import * as React from 'react';
import { IListItem } from '@nkr/models/index';
import { Radio, ControlLabel, FormControl, FormGroup, Row } from 'react-bootstrap';

interface IProps {
    recpAddress: string,
    recpCity: string,
    recpState: string,
    recpZipCode: string,
    recpIcdCode: string,
    recpMedicareNumber: string,
    recpParentChildTransplant: boolean,
    handleIcdType: (e: React.FormEvent<FormControl & HTMLSelectElement>) => void,
    handleParentChildTransplantSelect: (e: boolean) => void,
    handleInputChange: (e: React.FormEvent<FormControl & HTMLInputElement>) => void
}

class RecipientAddressInfo extends React.Component<IProps> {

    render = () => {
        return (
            <div className='col-sm-12'>
                <Row>
                    <div className='col-sm-12'>
                        <FormGroup controlId="addressText">
                            <ControlLabel>Address</ControlLabel>
                            <FormControl
                                type="text"
                                name="recpAddress"
                                value={this.props.recpAddress}
                                placeholder="Enter Address"
                                onChange={this.props.handleInputChange}
                            />
                            <FormControl.Feedback />
                        </FormGroup>
                    </div>
                </Row>

                <Row>
                    <div className='col-sm-4'>
                        <FormGroup controlId="cityText">
                            <ControlLabel>City</ControlLabel>
                            <FormControl
                                type="text"
                                name="recpCity"
                                value={this.props.recpCity}
                                placeholder="Enter City"
                                onChange={this.props.handleInputChange}
                            />
                            <FormControl.Feedback />
                        </FormGroup>
                    </div>
                    <div className='col-sm-4'>
                        <FormGroup controlId="stateText">
                            <ControlLabel>State</ControlLabel>
                            <FormControl
                                type="text"
                                name="recpState"
                                maxLength={2}
                                value={this.props.recpState}
                                placeholder="Enter State"
                                onChange={this.props.handleInputChange}
                            />
                            <FormControl.Feedback />
                        </FormGroup>
                    </div>
                    <div className='col-sm-4'>
                        <FormGroup controlId="zipCodeText">
                            <ControlLabel>Postal Code</ControlLabel>
                            <FormControl
                                type="text"
                                name="recpZipCode"
                                value={this.props.recpZipCode}
                                placeholder="Enter Postal Code"
                                onChange={this.props.handleInputChange}
                            />
                            <FormControl.Feedback />
                        </FormGroup>
                    </div>
                </Row>
                
                <Row>
                    <div className='col-sm-6'>
                        <FormGroup controlId="formControlsSelect">
                            <ControlLabel>Type</ControlLabel>
                            <FormControl 
                            onChange={this.props.handleIcdType} 
                            value={this.props.recpIcdCode} 
                            componentClass="select" placeholder="select">
                                <option value="select">Select ICD Code</option>
                                    <option value="Z48.22">Z48.22</option>
                                    <option value="Z48.0">Z94.0</option>
                            </FormControl>
                        </FormGroup>
                    </div>
                    <div className='col-sm-6'>
                        <ControlLabel>Parent/Child Transplant?</ControlLabel>
                        <FormGroup 
                            name='recpParentChildTransplant'>
                            <Radio name="recpParentChildTransplant" checked={this.props.recpParentChildTransplant} 
                        onClick={() => this.props.handleParentChildTransplantSelect(true)} inline>
                                True
                            </Radio>{' '}
                            <Radio name="recpParentChildTransplant" checked={!this.props.recpParentChildTransplant} 
                            onClick={() => this.props.handleParentChildTransplantSelect(false)} inline>
                                False
                            </Radio>{' '}
                        </FormGroup>
                    </div>
                </Row>
            </div>
        )
    }
}

export default RecipientAddressInfo;